import type { ReactNode } from 'react';

interface QuestionnaireResultHeroProps {
  title: string;
  value: ReactNode;
  valueColor?: string;
  valueCaption?: ReactNode;
  classification: ReactNode;
  supportingText?: ReactNode;
  interpretation: ReactNode;
  children?: ReactNode;
}

export default function QuestionnaireResultHero({
  title,
  value,
  valueColor = '#0f172a',
  valueCaption,
  classification,
  supportingText,
  interpretation,
  children,
}: QuestionnaireResultHeroProps) {
  return (
    <div className="grid gap-6 md:grid-cols-5">
      <div className="rounded-[28px] border border-slate-200 bg-white p-8 text-center shadow-sm md:col-span-2">
        <p className="mb-4 text-xs font-black uppercase tracking-[0.25em] text-primary-700">{title}</p>
        <div className="text-6xl font-black leading-none" style={{ color: valueColor }}>
          {value}
        </div>
        {valueCaption ? <div className="mt-2 text-sm font-semibold text-slate-700">{valueCaption}</div> : null}
        <div className="mt-5 inline-flex items-center justify-center gap-2 text-sm font-bold" style={{ color: valueColor }}>
          <span className="h-2 w-2 shrink-0 rounded-full bg-current" aria-hidden="true" />
          <span>{classification}</span>
        </div>
        {supportingText ? <div className="mt-3 text-xs font-medium leading-relaxed text-slate-500">{supportingText}</div> : null}
      </div>

      <div className="flex flex-col justify-center space-y-4 md:col-span-3">
        <div>
          <h4 className="text-2xl font-black tracking-tight text-slate-800">Interpretação</h4>
          <div className="mt-3 max-w-4xl text-sm leading-relaxed text-slate-600">{interpretation}</div>
        </div>
        {children}
      </div>
    </div>
  );
}
